// 百分比格式化过滤器
export function percentFilter(value, decimal = 2) {
  // 容错处理：空值、非数字返回空字符串，避免显示 NaN%
  if (value === undefined || value === null || isNaN(Number(value))) {
    return "";
  }
  // decimal：可选参数，控制小数位数，默认保留2位
  return (Number(value) * 100).toFixed(decimal) + "%";
}
